module.exports = __webpack_public_path__ + "img/xianfengmiliang.45dfdb9e.jpg";